import storeModule from '../../../store-module'
import { defineStore } from 'pinia'

const url = 'active-offers/campaigns'

export default defineStore(
  'active-offers-campaigns',
  storeModule.createStoreModule('active-offers-campaigns', {
    createURL: url,
    fetchFiltersURL: `${url}/filters`,
    fetchListURL: url,
    fetchSingleURL: ({ id }) => id ? `${url}/${id}` : `${url}/new`
  })
)
